import React from 'react';
import { motion } from 'framer-motion';
import { 
  FaReact, FaNode, FaDatabase, FaPython, FaDocker, 
  FaGitAlt, FaAws, FaJava, 
  FaAngular,
  FaJira,
  FaNodeJs
} from 'react-icons/fa';
import { 
  SiExpress, SiMongodb, SiPostgresql, SiRedis, SiJavascript,
  SiTypescript, SiGraphql, SiSwagger, SiSocketdotio,
  SiSpringboot,
  SiOracle,
  SiMysql,
  SiAzuredevops,
  SiPostman,
  SiDatadog,
  SiSonar,
  SiXaml,
  SiJson,
  SiSpringsecurity,
  SiHibernate
} from 'react-icons/si';
import './Technologies.css';

const Technologies = () => {
  const techCategories = [

    {
      title: 'Backend',
      icon: <SiSpringboot />,
      techs: [

        { name: 'Java', icon: <FaJava />, color: '#a6311e' },
        { name: 'Spring Boot', icon: <SiSpringboot />, color: '#339933' },
        { name: 'Hibernate', icon: <SiHibernate />, color: '#596859' },
        { name: 'NodeJs', icon: < FaNodeJs/>, color: '#339933' },
      ]
    },
    {
      title: 'Frontend',
      icon: <FaReact />,
      techs: [
        { name: 'React', icon: <FaReact />, color: '#61DAFB' },
        { name: 'Angular', icon: <FaAngular/>, color: '#a6311e' },
        { name: 'JavaScript', icon: <SiJavascript />, color: '#F7DF1E' },
        { name: 'TypeScript', icon: <SiTypescript />, color: '#3178C6' }
      ]
    },
    {
      title: 'Databases',
      icon: <FaDatabase />,
      techs: [

        { name: 'PostgreSQL', icon: <SiPostgresql />, color: '#4169E1' },
        { name: 'MongoDB', icon: <SiMongodb />, color: '#47A248' },
        { name: 'Oracle', icon: <SiOracle />, color: '#DC382D' },
        { name: 'MySQL', icon: <SiMysql />, color: '#4169E1' }

      ]
    },
    {
      title: 'Tools & DevOps',
      icon: <FaDocker />,
      techs: [
        { name: 'Docker', icon: <FaDocker />, color: '#2496ED' },
        { name: 'Git', icon: <FaGitAlt />, color: '#F05032' },
        { name: 'Azure DevOps', icon: <SiAzuredevops />, color: '#2496ED' },
        { name: 'AWS', icon: <FaAws />, color: '#FF9900' }
      ]
    },
    {
      title: 'Testing & Quality',
      icon: <SiSwagger />,
      techs: [
        { name: 'Postman', icon: <SiPostman />, color: '#bc470d' },
        { name: 'Datadog', icon: <SiDatadog />, color: '#803da1' },
        { name: 'SonarQube', icon: <SiSonar />, color: '#2872b3' },
        { name: 'Swagger', icon: <SiSwagger />, color: '#85EA2D' }
      ]
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };

  return (
    <section id="technologies" className="section technologies">
      <div className="container">
        <motion.h2 
          className="section-title gradient-text"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          Technologies
        </motion.h2>

        <motion.div 
          className="tech-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {techCategories.map((category, idx) => (
            <motion.div 
              key={idx}
              className="tech-card"
              variants={itemVariants}
              whileHover={{ 
                y: -10,
                boxShadow: '0 20px 40px rgba(0, 212, 255, 0.2)'
              }}
            >
              <div className="tech-card-header">
                <div className="tech-category-icon">{category.icon}</div>
                <h3>{category.title}</h3>
              </div>

              <div className="tech-list">
                {category.techs.map((tech, techIdx) => (
                  <motion.div 
                    key={techIdx}
                    className="tech-item"
                    whileHover={{ scale: 1.05, x: 5 }}
                    transition={{ type: 'spring', stiffness: 300 }}
                  >
                    <span 
                      className="tech-icon" 
                      style={{ color: tech.color }}
                    >
                      {tech.icon}
                    </span>
                    <span className="tech-name">{tech.name}</span>
                  </motion.div>
                ))}
              </div>
            </motion.div>
          ))}
        </motion.div>

        <motion.div 
          className="tech-highlight"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.5, duration: 0.8 }}
        >
          <h3>Specializations</h3>
          <div className="highlights-grid">

            <div className="highlight-item">
              <span className="highlight-icon">📡</span>
              <h4>RESTful APIs</h4>
              <p>Design and implementation of scalable and well-documented APIs</p>
            </div>
            <div className="highlight-item">
              <span className="highlight-icon">🧩</span>
              <h4>Microservices Architecture</h4>
              <p>Design and implementation of scalable, resilient, and loosely coupled microservices</p>
            </div>
            <div className="highlight-item">
              <span className="highlight-icon">🗄️</span>
              <h4>Database Design & PL/SQL</h4>
              <p>Design of relational schemas, ERD modeling, stored procedures and performance optimization</p>
            </div>
            <div className="highlight-item">
              <span className="highlight-icon">🔐</span>
              <h4>JWT Authentication</h4>
              <p>Implementation of secure authentication and authorization systems</p>

            </div>
            <div className="highlight-item">
              <span className="highlight-icon">⚡</span>
              <h4>WebSockets</h4>
              <p>Real-time communication for interactive applications</p>
            </div>
            <div className="highlight-item">
              <span className="highlight-icon">📚</span>
             <h4>Swagger / OpenAPI</h4>
             <p>Interactive API documentation and endpoint testing</p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Technologies;
